"use client";
import React, { useEffect, useState } from "react";

import useGlobalContext from "@sendmagic/prismic-nextjs/src/hooks/useGlobalContext";

const withExtendedStyles = (Component, getStyles) => {
  function WrappingComponent(props) {
    const [styles, setStyles] = useState();

    const { appName } = useGlobalContext();

    const { styleImport } = getStyles({ appName });

    useEffect(() => {
      const setSliceStyles = async () => {
        const sliceStyles = await styleImport();
        setStyles(sliceStyles.default || sliceStyles);
      };
      setSliceStyles();
    }, [styleImport]);

    if (!styleImport || styles) {
      return <Component {...props} sliceStyles={styles} />;
    }
    return "";
  }
  return WrappingComponent;
};

export default withExtendedStyles;
